import React, { useState, useEffect } from "react";
import { HTTP } from "../../api/http-common";
import { useNavigate, Link } from "react-router-dom";
import { isValidEmail } from '../../component/common';
import { Eye, EyeOff } from "lucide-react";
import Swal from 'sweetalert2'
import { useGlobalContext } from "./../../component/GlobalContext";
import ReCAPTCHA from "react-google-recaptcha";

function Vendor() {
    const [captchaValue, setCaptchaValue] = useState(null);
    const { usermailToVerify, setUsermailToVerify } = useGlobalContext();
    const navigate = useNavigate();
    const [firstName, setFirstName] = useState("");
    const [firstNameError, setFirstNameError] = useState("");
    const [lastName, setLastName] = useState("");
    const [lastNameError, setLastNameError] = useState("");
    const [businessName, setBusinessName] = useState("");
    const [businessNameError, setBusinessNameError] = useState("");
    const [businessDescription, setBusinessDescription] = useState("");
    // const [businessDescriptionError, setBusinessDescriptionError] = useState("");
    const [phoneNumber, setPhoneNumber] = useState("");
    const [phoneNumberError, setPhoneNumberError] = useState("");
    const [email, setEmail] = useState("");
    const [emailError, setEmailError] = useState("");
    const [password, setPassword] = useState("");
    const [passwordError, setPasswordError] = useState("");
    const [cpassword, setCPassword] = useState("");
    const [passwordShow, setPasswordShow] = useState(false);
    const [cpasswordShow, setcPasswordShow] = useState(false);
    const [categoryId, setCategoryId] = useState("");
    const [categoryIdError, setCategoryIdError] = useState("");
    const [pagination, setPagination] = useState({ page: '1', limit: '100' });

    const handleCategoryTypeChange = (e) => {
        setCategoryId(e.target.value);
    };
    const [categoriesList, setCategoriesList] = useState([]);

    useEffect(() => {
        loadCategories();
    }, []);

    const loadCategories = async () => {
        try {
            let fields = {
                filters: {
                    // coupon_type: filterType
                },
                pagination: pagination,
                sorting: { field: 'id', type: 'desc' },
            };
            await HTTP.post("/business_cate/list/all", fields)
                .then(async (response) => {
                    if (response.status === 200) {
                        setCategoriesList(response.data.contents)
                    }
                })
                .catch((error) => {
                    // setError(error);
                    // setRerenderFlag(true);
                    // loadAaMasterData();
                    // resetValidationErrors();
                });

            // setIsLoading(false);
        } catch (error) {
            // setError(error);
            // setRerenderFlag(true);
            // setIsLoading(false);
        }
    }

    const resetValidationErrors = () => {
        setFirstNameError('');
        setLastNameError('');
        setBusinessNameError('');
        // setBusinessDescriptionError('');
        setPhoneNumberError('');
        setEmailError('');
        setPasswordError('');
        setCategoryIdError('');
    };
    const hideShowPass = () => {
        setPasswordShow(!passwordShow);
    }
    const hideShowcPass = () => {
        setcPasswordShow(!cpasswordShow);
    }


    const validateField = () => {
        resetValidationErrors();

        let checked = true;
        if (firstName === '') {
            setFirstNameError('Please enter first name');
            if (checked) {
                checked = false;
            }
        } else if (firstName.length < 3) {
            setFirstNameError("Please enter minimum 3 characters");
            if (checked) {
                checked = false;
            }
        } else if (firstName.length > 100) {
            setFirstNameError("Max character limit is 100");
            if (checked) {
                checked = false;
            }
        }

        if (lastName === '') {
            setLastNameError('Please enter last name');
            if (checked) {
                checked = false;
            }
        } else if (lastName.length < 3) {
            setLastNameError("Please enter minimum 3 characters");
            if (checked) {
                checked = false;
            }
        } else if (lastName.length > 100) {
            setLastNameError("Max character limit is 100");
            if (checked) {
                checked = false;
            }
        }
        if (businessName === '') {
            setBusinessNameError('Please enter business name');
            if (checked) {
                checked = false;
            }
        // } else if (businessName.length < 5) {
        //     setBusinessNameError("Please enter minimum 5 characters");
        //     if (checked) {
        //         checked = false;
        //     }
        } else if (businessName.length > 100) {
            setBusinessNameError("Max character limit is 100");
            if (checked) {
                checked = false;
            }
        }

        if (categoryId === '') {
            setCategoryIdError('Select business category');
            if (checked) {
                checked = false;
            }
        }

        // if (businessDescription === '') {
        //     setBusinessDescriptionError('Please enter business description');
        //     if (checked) {
        //         checked = false;
        //     }
        // } else if (businessDescription.length < 5) {
        //     setBusinessDescriptionError("Please enter minimum 5 characters");
        //     if (checked) {
        //         checked = false;
        //     }
        // } else if (businessDescription.length > 100) {
        //     setBusinessDescriptionError("Max character limit is 1000");
        //     if (checked) {
        //         checked = false;
        //     }
        // }

        if (phoneNumber === '') {
            setPhoneNumberError('Please enter phone number');
            if (checked) {
                checked = false;
            }
        } else if (phoneNumber.length > 100) {
            setPhoneNumberError("Max character limit is 10");
            if (checked) {
                checked = false;
            }
        }

        if (email === '') {
            setEmailError('Please enter email address');
            if (checked) {
                checked = false;
            }
        }
        else if (!isValidEmail(email)) {
            setEmailError('Invalid email.');
            if (checked) {
                checked = false;
            }
        } else if (email.length > 100) {
            setEmailError("Max character limit is 100");
            if (checked) {
                checked = false;
            }
        }

        const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#&?])[A-Za-z\d!@#&?]{8,64}$/;

        console.log(passwordRegex.test(password))
        let errorMessage = '';
        if (password === '') {
            setPasswordError('Please enter password');
            if (checked) {
                checked = false;
            }
        }
        // else if (!passwordRegex.test(password)) {
        //     errorMessage = `Password must:
        //     - Be 8-64 characters long
        //     - Include both uppercase and lowercase letters
        //     - Contain both letters and numbers
        //     - Include at least one special character (e.g., ! @ # & ?)`;
        //     setPasswordError(errorMessage);
        //     if (checked) {
        //         checked = false;
        //     }
        // }
        if (cpassword === '') {
            setPasswordError('Please enter confirm password');
            if (checked) {
                checked = false;
            }
        }
        if (password !== cpassword) {
            setPasswordError('Please confirm password');
            if (checked) {
                checked = false;
            }
        }

        return checked;
    };
    const handleSubmit = async () => {
        if (validateField()) {
            if (!captchaValue) {
                alert("Please verify reCAPTCHA");
                return;
            }
            try {
                // setIsLoading(true);
                // let config = {
                //   headers: { "Content-Type": "application/json", token: access_token },
                // };

                let fields = {
                    owner_first_name: firstName,
                    owner_last_name: lastName,
                    business_name: businessName,
                    business_description: businessDescription,
                    phone_number: phoneNumber,
                    business_category_id: categoryId,
                    email: email,
                    password: password,
                    business_site_url: ''
                };


                await HTTP.post(
                    "/vendors/register",
                    fields,
                    // config
                )
                    .then(async (response) => {
                        if (response.status === 200) {
                            Swal.fire({
                                title: "Registered successfully!",
                                text: "Please verify your email before login",
                                icon: "success"
                            });
                            localStorage.setItem('registered_email',email);
                            localStorage.setItem('role','vendor');
                            setUsermailToVerify(email);
                            navigate('/verify');
                        }
                    })
                    .catch((error) => {
                        if (error.response.status === 406) {
                            resetValidationErrors();
                            setPasswordError(error.response.data.detail);
                        }
                        if (error.response.status === 400) {
                            Swal.fire({
                                title: 'Error!',
                                text: 'You are already registered!',
                                icon: 'error',
                                confirmButtonText: 'Ok'
                            })
                        }
                        // setError(error);
                        // setRerenderFlag(true);
                        // loadAaMasterData();
                        // resetValidationErrors();
                    });

                // setIsLoading(false);
            } catch (error) {
                // setError(error);
                // setRerenderFlag(true);
                // setIsLoading(false);
            }
        }
    };
    return (
        <>
            <div
                className="rounded-xl border bg-card text-card-foreground w-full p-8 shadow-sm max-w-[650px] my-3 min-h-[450px]"
            // style={{ maxHeight: "580px", height: "100%", overflow: "scroll" }}
            >
                <div className="flex gap-6 mb-6 mt-4">
                    <button className="text-2xl font-semibold">Business Partner Registration</button>
                </div>
                <div className="gap-8">
                    <div className="flex flex-wrap">

                        {/* Owner First Name */}
                        <div className=" w-1/2 my-2 relative pr-3">
                            <div className="relative space-y-1">
                                <input
                                    className="peer w-full focus:outline-none focus:border-b focus:border-gray-400 peer h-10 px-0 bg-transparent border-0 border-b input-border-bottom rounded-none focus-visible:ring-0 focus-visible:border-gray-400 placeholder:text-gray-400"
                                    placeholder=" "
                                    name="firstName"
                                    value={firstName}
                                    onChange={(e) => {
                                        setFirstName(e.target.value);
                                    }}
                                />
                            </div>
                            <label
                                className="absolute left-0 -top-2 text-xs text-gray-500 transition-all peer-placeholder-shown:top-2.5 peer-placeholder-shown:text-base peer-placeholder-shown:text-gray-400 peer-focus:-top-2 peer-focus:text-xs peer-focus:text-gray-500"
                            >
                                Owner First Name
                            </label>
                            {firstNameError && <span className="text-sm text-red-500">{firstNameError}</span>}
                        </div>
                        {/* Last Name */}
                        <div className="w-1/2 my-2 px-3 relative space-y-1">
                            <div className="relative space-y-1">
                                <input
                                    className="peer w-full focus:outline-none focus:border-b focus:border-gray-400 peer h-10 px-0 bg-transparent border-0 border-b input-border-bottom rounded-none focus-visible:ring-0 focus-visible:border-gray-400 placeholder:text-gray-400"
                                    placeholder=" "
                                    name="lastName"
                                    value={lastName}
                                    onChange={(e) => {
                                        setLastName(e.target.value);
                                    }}
                                />
                            </div>
                            <label
                                className="absolute left-3 -top-2 text-xs text-gray-500 transition-all peer-placeholder-shown:top-2.5 peer-placeholder-shown:text-base peer-placeholder-shown:text-gray-400 peer-focus:-top-2 peer-focus:text-xs peer-focus:text-gray-500"
                            >
                                Owner Last Name
                            </label>
                            {lastNameError && <span className="text-sm text-red-500">{lastNameError}</span>}
                        </div>
                        {/* Business Name */}
                        <div className="w-1/2 my-2 relative pr-3">
                            <div className="relative space-y-1">
                                <input
                                    className="peer w-full focus:outline-none focus:border-b focus:border-gray-400 peer h-10 px-0 bg-transparent border-0 border-b input-border-bottom rounded-none focus-visible:ring-0 focus-visible:border-gray-400 placeholder:text-gray-400"
                                    placeholder=" "
                                    name="firstName"
                                    value={businessName}
                                    onChange={(e) => {
                                        setBusinessName(e.target.value);
                                    }}
                                />
                            </div>
                            <label
                                className="absolute left-0 -top-2 text-xs text-gray-500 transition-all peer-placeholder-shown:top-2.5 peer-placeholder-shown:text-base peer-placeholder-shown:text-gray-400 peer-focus:-top-2 peer-focus:text-xs peer-focus:text-gray-500"
                            >
                                Business Name
                            </label>
                            {businessNameError && <span className="text-sm text-red-500">{businessNameError}</span>}
                        </div>

                        {/** Business Category */}
                        <div className="w-1/2 my-2 relative pr-3">
                            <select
                                className="peer w-full focus:outline-none focus:border-b focus:border-gray-400 peer h-10 px-0 bg-transparent border-0 border-b input-border-bottom rounded-none focus-visible:ring-0 focus-visible:border-gray-400 placeholder:text-gray-400"
                                name="business_category"
                                value={categoryId}
                                onChange={handleCategoryTypeChange}
                            >
                                <option value="">Select Type</option>
                                {Array.isArray(categoriesList) && categoriesList.length > 0
                                    ? categoriesList.map((noticationType) => (
                                        <option key={noticationType.id} value={noticationType.id}>
                                            {noticationType.name}
                                        </option>
                                    ))
                                    : null}
                            </select>
                            <label
                                className="absolute left-2 -top-2 text-xs text-gray-500 transition-all
                    peer-placeholder-shown:top-2.5 peer-placeholder-shown:text-base peer-placeholder-shown:text-gray-400
                    peer-focus:-top-2 peer-focus:text-xs peer-focus:text-gray-500"
                            >
                                Business Category
                            </label>
                            {categoryIdError && <span className="text-sm text-red-500">{categoryIdError}</span>}
                        </div>
                        {/* Business Description */}
                        <div className="w-full  mt-6 mb-2 relative space-y-1">
                            <label
                                className="absolute left-0 top-[-18px] text-xs text-gray-500 transition-all peer-placeholder-shown:top-2.5 peer-placeholder-shown:text-base peer-placeholder-shown:text-gray-400 peer-focus:-top-2 peer-focus:text-xs peer-focus:text-gray-500"
                            >
                                Business Description
                            </label>
                            <textarea
                                type=""
                                row="4"
                                id="business_description"
                                name="business_description"
                                // className="peer w-full focus:outline-none focus:border-b focus:border-gray-400 placeholder:text-gray-400 peer h-10 px-0 bg-transparent border-0 border-b input-border-bottom rounded-none focus-visible:ring-0 focus-visible:border-gray-400"
                                className="w-full p-2 border rounded-lg whitespace-pre-wrap"
                                value={businessDescription}
                                onChange={(e) => {
                                    setBusinessDescription(e.target.value);
                                }}
                            />
                            {/* {businessDescriptionError && <span className="text-sm text-red-500">{businessDescriptionError}</span>} */}
                        </div>

                        {/* Phone Number */}
                        <div className="w-1/2 my-2 relative pr-3">
                            <div className="relative space-y-1">
                                <input
                                    className="peer w-full focus:outline-none focus:border-b focus:border-gray-400 peer h-10 px-0 bg-transparent border-0 border-b input-border-bottom rounded-none focus-visible:ring-0 focus-visible:border-gray-400 placeholder:text-gray-400"
                                    placeholder=" "
                                    name="firstName"
                                    value={phoneNumber}
                                    onChange={(e) => {
                                        setPhoneNumber(e.target.value);
                                    }}
                                />
                            </div>
                            <label
                                className="absolute left-0 -top-2 text-xs text-gray-500 transition-all peer-placeholder-shown:top-2.5 peer-placeholder-shown:text-base peer-placeholder-shown:text-gray-400 peer-focus:-top-2 peer-focus:text-xs peer-focus:text-gray-500"
                            >
                                Phone Number
                            </label>
                            {phoneNumberError && <span className="text-sm text-red-500">{phoneNumberError}</span>}
                        </div>

                        {/* Email */}
                        <div className="w-1/2 my-2 relative pr-3">
                            <div className="relative space-y-1">
                                <input
                                    type="email"
                                    className="peer w-full focus:outline-none focus:border-b focus:border-gray-400 peer h-10 px-0 bg-transparent border-0 border-b input-border-bottom rounded-none focus-visible:ring-0 focus-visible:border-gray-400 placeholder:text-gray-400"
                                    placeholder=" "
                                    name="email"
                                    value={email}
                                    onChange={(e) => {
                                        setEmail(e.target.value);
                                    }}
                                />
                            </div>
                            <label
                                className="absolute left-0 -top-2 text-xs text-gray-500 transition-all peer-placeholder-shown:top-2.5 peer-placeholder-shown:text-base peer-placeholder-shown:text-gray-400 peer-focus:-top-2 peer-focus:text-xs peer-focus:text-gray-500"
                            >
                                Email
                            </label>
                            {emailError && <span className="text-sm text-red-500">{emailError}</span>}
                        </div>
                        {/* Password */}
                        <div className="w-1/2 my-2 relative pr-3">
                            <div className="relative space-y-1">
                                <input
                                    type={passwordShow ? "text" : "password"}
                                    className="peer w-full focus:outline-none focus:border-b focus:border-gray-400 peer h-10 px-0 bg-transparent border-0 border-b input-border-bottom rounded-none focus-visible:ring-0 focus-visible:border-gray-400 placeholder:text-gray-400"
                                    placeholder=" "
                                    name="password"
                                    value={password}
                                    onChange={(e) => {
                                        setPassword(e.target.value);
                                    }}
                                />
                                <button
                                    type="button"
                                    className="absolute right-0 bottom-2 text-gray-400"
                                    onClick={hideShowPass}
                                >
                                    {passwordShow ? <EyeOff className="mr-2 h-4 w-4" /> : <Eye className="mr-2 h-4 w-4" />}
                                </button>
                            </div>
                            <label
                                className="absolute left-0 -top-2 text-xs text-gray-500 transition-all peer-placeholder-shown:top-2.5 peer-placeholder-shown:text-base peer-placeholder-shown:text-gray-400 peer-focus:-top-2 peer-focus:text-xs peer-focus:text-gray-500"
                            >
                                Password
                            </label>
                            {passwordError && <span className="text-sm text-red-500">{passwordError}</span>}
                        </div>
                        {/* Confirm Password */}
                        <div className="w-1/2 my-2 relative pr-3">
                            <div className="relative space-y-1">
                                <input
                                    type={cpasswordShow ? "text" : "password"}
                                    className="peer w-full focus:outline-none focus:border-b focus:border-gray-400 peer h-10 px-0 bg-transparent border-0 border-b input-border-bottom rounded-none focus-visible:ring-0 focus-visible:border-gray-400 placeholder:text-gray-400"
                                    placeholder=" "
                                    name="confirm_password"
                                    value={cpassword}
                                    onChange={(e) => {
                                        setCPassword(e.target.value);
                                    }}
                                />
                                <button
                                    type="button"
                                    className="absolute right-0 bottom-2 text-gray-400"
                                    onClick={hideShowcPass}
                                >
                                    {cpasswordShow ? <EyeOff className="mr-2 h-4 w-4" /> : <Eye className="mr-2 h-4 w-4" />}
                                </button>
                            </div>
                            <label
                                className="absolute left-0 -top-2 text-xs text-gray-500 transition-all peer-placeholder-shown:top-2.5 peer-placeholder-shown:text-base peer-placeholder-shown:text-gray-400 peer-focus:-top-2 peer-focus:text-xs peer-focus:text-gray-500"
                            >
                                Confirm Password
                            </label>
                        </div>

                    </div>









                    <ReCAPTCHA
                        sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
                        onChange={(value) => setCaptchaValue(value)}
                        className="my-4"

                    />
                    
                    {/* Submit Button */}
                    <div className="flex flex-col items-center justify-center">
                    <button
                        className="inline-flex items-center justify-center gap-2 whitespace-nowrap text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 [&amp;_svg]:pointer-events-none [&amp;_svg]:size-4 [&amp;_svg]:shrink-0 shadow px-4 py-2 w-full h-8 bg-[#6C38FF] hover:bg-[#5b2ee6] text-white rounded-lg mt-2 login-page-button-wrapper"
                        type="submit"
                        onClick={handleSubmit}
                    >
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            className="lucide lucide-user mr-2 h-5 w-5"
                        >
                            <path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2"></path>
                            <circle cx="12" cy="7" r="4"></circle>
                        </svg>
                        Register
                    </button>
                    
                    </div>
                    {/* Sign In */}
                    <div className="flex items-center justify-center mt-4 ">
                        <span className="text-sm mx-1 font-bold"> Registered ?</span>
                        <Link
                            to="/vendor/login"
                            className="theme-color  text-sm inline-flex items-center"
                        >
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                className="lucide lucide-log-in mr-2 h-4 w-4"
                            >
                                <path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4"></path>
                                <polyline points="10 17 15 12 10 7"></polyline>
                                <line x1="15" x2="3" y1="12" y2="12"></line>
                            </svg>

                            Sign In
                        </Link>
                    </div>
                   
                    
                </div>
            </div>

        </>
    )
}

export default Vendor